// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__27OvE","headerAmount":"styles_headerAmount__3PkJq","row":"styles_row__2OKgd","amountRow":"styles_amountRow__2G6Cc"};